import { Directive, ElementRef, HostListener } from '@angular/core'
import { faro } from '@grafana/faro-web-sdk'

/**
 * Workaround: o UserActionInstrumentation do Faro acessa event.target.dataset diretamente
 * sem percorrer o DOM para cima. Em botões Angular Material, event.target é um elemento
 * filho (mat-icon, span, ripple) que não possui o atributo data-faro-user-action-name.
 *
 * Este directive escuta pointerdown no host e dispara startUserAction manualmente
 * quando o atributo está presente no elemento host.
 */
@Directive({
  selector: '[data-faro-user-action-name]',
  standalone: true,
})
export class FaroUserActionDirective {
  private actionName: string | undefined

  constructor(private el: ElementRef<HTMLElement>) {
    this.actionName = this.el.nativeElement.dataset['faroUserActionName']
  }

  @HostListener('pointerdown')
  onPointerDown() {
    if (this.actionName && faro?.api) {
      faro.api.startUserAction(this.actionName, {}, { triggerName: 'pointerdown' })
    }
  }
}
